import { render, staticRenderFns } from "./mocDashboard.vue?vue&type=template&id=7b9c7e80"
import script from "./mocDashboard.vue?vue&type=script&lang=js"
export * from "./mocDashboard.vue?vue&type=script&lang=js"
import style0 from "./mocDashboard.vue?vue&type=style&index=0&id=7b9c7e80&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b9c7e80')) {
      api.createRecord('7b9c7e80', component.options)
    } else {
      api.reload('7b9c7e80', component.options)
    }
    module.hot.accept("./mocDashboard.vue?vue&type=template&id=7b9c7e80", function () {
      api.rerender('7b9c7e80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/moc/mocDashboard.vue"
export default component.exports